
import {
  IonGrid,
  IonRow,
  IonCol,
  IonInput
} from '@ionic/vue';
import { defineComponent, onMounted, PropType, ref, Ref, toRef } from "vue";
import axiosInstance from "@/axiosInstance";
import frTranslations from '@/locales/fr.json';
import AutoFillSelect from '@/components/AutoFillSelect.vue';
import { MethanizationData } from '@/types/MethanizationData';

export default defineComponent({
  name: "MethanizationDataForm",
  components: {
    IonGrid,
    IonRow,
    IonCol,
    IonInput,
    AutoFillSelect
  },
  props: {
    companyId: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  setup(props) {
    const currentLanguage = ref('fr');
    const translations = {
      fr: frTranslations,
    };
    const dataLoaded = ref(false);
    const companyId = toRef(props, 'companyId');
    const data = ref<MethanizationData>({});
    const types = ref([]);
    const selectedType = ref<any>({});
    const productions = ref([]);
    const selectedProduction = ref<any>({});

    const submitForm = async () => {
      try {
        data.value = await updateData(companyId, data.value);
        dataLoaded.value = true;
      } catch (error) {
        console.error('Error updating production data:', error);
      }
    };

    const getTypes = async () => {
      try {
        const response = await axiosInstance.get(`api/core/methanization-types/`);
        return response.data;
      } catch (error) {
        console.error(error);
        return "";
      }
    };

    const getProductions = async () => {
      try {
        const response = await axiosInstance.get(`api/core/methanization-productions/`);
        return response.data;
      } catch (error) {
        console.error(error);
        return "";
      }
    };

    onMounted(async () => {
      data.value = await getData(companyId);
      types.value = await getTypes();
      if (data.value && data.value.type){
        selectedType.value = types.value.find((item: any) => item.id == data.value.type);
      }
      productions.value = await getProductions();
      if (data.value && data.value.production) {
        selectedProduction.value = productions.value.find((item: any) => item.id == data.value.production);
      }
      dataLoaded.value = true;
    });

    const getData = async (companyId: Ref<number>) => {
      try {
        const response = await axiosInstance.get(`api/core/methanization-data/${companyId.value}/`);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    };

    const updateData = async (companyId: Ref<number>, data: any) => {
      try {
        const response = await axiosInstance.put(`api/core/methanization-data/${companyId.value}/update/`, data);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    };

    const handleSelected = (option: any, item: any, field: string, update = false) => {
      item[field] = option ? option.id : null;
      if (field == 'type') {
        selectedType.value = option;
      }
      if (field == 'production') {
        selectedProduction.value = option;
      }
      if (update) {
        updateData(companyId, item);
      }
    }

    return {
      translations,
      currentLanguage,
      data,
      types,
      selectedType,
      productions,
      selectedProduction,
      submitForm,
      handleSelected,
    };
  },
});
